/**
 * 3D烟花展示系统 - 主入口文件
 * 
 * 该文件是应用程序的入口点，负责初始化和启动整个系统。
 */

// 导入样式
import './styles/main.css';

// 导入核心组件
import FireworksApp from './core/FireworksApp.js';

/**
 * 应用程序初始化
 */
function init() {
  console.log('3D烟花展示系统初始化中...');
  
  // 获取容器元素
  const container = document.getElementById('canvas-container');
  
  if (!container) {
    console.error('找不到canvas容器元素');
    displayError('初始化失败：找不到容器元素');
    return;
  }
  
  // 创建并启动应用实例
  try {
    const app = new FireworksApp(container);
    app.init();
    app.start();
    
    console.log('✓ 3D烟花展示系统启动成功！');
    console.log('点击按钮发射烟花，拖拽鼠标旋转视角');
    
    // 将app实例挂载到window以便调试
    window.fireworksApp = app;
    
  } catch (error) {
    console.error('应用初始化失败:', error);
    displayError('应用初始化失败，请检查浏览器是否支持WebGL');
  }
}

/**
 * 显示错误消息
 * @param {string} message - 错误消息
 */
function displayError(message) {
  const errorElement = document.getElementById('error-message');
  const errorText = document.getElementById('error-text');
  
  if (errorElement && errorText) {
    errorText.textContent = message;
    errorElement.classList.remove('hidden');
  }
}

// 等待DOM加载完成后初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
